import React from 'react';

const HistoryScreen = () => {
  return <>처치 히스토리</>;
};

export default HistoryScreen;
